import "reflect-metadata";
import { injectable } from "inversify-props";
import IAuth from "./IAuth";

@injectable()
export default class Auth implements IAuth {
  public Email = "";
  public Password = "";
}
